import type { IconProps } from "./thumba-coin";

export const ClockIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8.05176 6.6665V8.99984"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99951 2V4.17667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00085 4.3335C9.119 4.33401 10.1998 4.73599 11.0465 5.46626C11.8933 6.19653 12.4497 7.20655 12.6144 8.31249C12.7792 9.41844 12.5414 10.5468 11.9443 11.4922C11.3472 12.4375 10.4305 13.1371 9.36109 13.4635C8.29165 13.79 7.14055 13.7216 6.1173 13.2708C5.09404 12.82 4.26666 12.0168 3.78574 11.0073C3.30481 9.99789 3.20232 8.84932 3.49691 7.77068C3.7915 6.69203 4.46359 5.75501 5.39085 5.13016"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66699 2H9.33366"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.3633 4.02991L12.9699 4.63657"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
